import { Grid, Box, VStack, Image, Text, HStack } from "@chakra-ui/react";
import { GradientBorderContainer } from "../../containers/GradientBorderContainer";
import { FeatureValuePropType } from "../types";
import { CheckIcon } from "../../icons/CheckIcon";

export function FeatureValueProps({
  valueProps,
}: {
  valueProps: FeatureValuePropType[];
}) {
  const isSimplified = !valueProps[0]?.icon_url;

  if (isSimplified) {
    return (
      <VStack gap={3} alignItems="start">
        {valueProps.map((valueProp, i) => (
          <SimpleFeatureValueProp key={i} valueProp={valueProp} />
        ))}
      </VStack>
    );
  }

  return (
    <Grid templateColumns="repeat(2, 1fr)" w="100%" gap={3}>
      {valueProps.map((valueProp, i) => (
        <FeatureValueProp key={i} valueProp={valueProp} />
      ))}
    </Grid>
  );
}

function SimpleFeatureValueProp({
  valueProp,
}: {
  valueProp: FeatureValuePropType;
}) {
  return (
    <HStack gap={2} alignItems="center">
      <CheckIcon color="neutral.300" boxSize="26px" flexShrink={0} />
      <Text
        fontFamily="Roboto"
        fontSize={{ base: "14px", md: "16px" }}
        fontWeight="400"
        lineHeight="150%"
        color="neutral.50"
      >
        {valueProp.body}
      </Text>
    </HStack>
  );
}

export function FeatureValueProp({
  valueProp,
}: {
  valueProp: FeatureValuePropType;
}) {
  // 40px is the height of the icon
  const ICON_SIZE = 10;
  return (
    <Box pt={ICON_SIZE / 2} position="relative">
      <Image
        position="absolute"
        zIndex={2}
        boxSize={ICON_SIZE}
        top={0}
        left="50%"
        transform="translateX(-50%)"
        alt={valueProp.header}
        src={valueProp.icon_url}
      />
      <GradientBorderContainer
        borderRadius="8px"
        topColor={valueProp.border_color![0]}
        bottomColor={valueProp.border_color![1]}
        backgroundDirection="45deg"
        height="100%"
      >
        <VStack
          alignItems="center"
          width="100%"
          gap={1}
          borderRadius="8px"
          p="32px 16px 16px 16px"
          background={`linear-gradient(45deg, ${valueProp.background_color![0]}, ${valueProp.background_color![1]})`}
        >
          <Text variant="paymentFeatureValuePropHeader">
            {valueProp.header}
          </Text>
          <Text
            variant="paymentFeatureValuePropBody"
            dangerouslySetInnerHTML={{ __html: valueProp.body }}
          />
        </VStack>
      </GradientBorderContainer>
    </Box>
  );
}
